export interface PageSEO {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
}

export const seoConfig: Record<string, PageSEO> = {
  home: {
    title: 'Desguace Gavá 【2026】Compramos tu Coche Siniestrado HOY | Pago Inmediato + Recogida GRATIS 24h | ☎️ 932 932 913',
    description: '🥇 Desguace Gavá #1 en Baix Llobregat. Compramos tu coche siniestrado, averiado o para chatarra HOY. ✅ Recogida GRATIS en 24h ✅ Pago INMEDIATO en efectivo ✅ Gestión de baja DGT incluida ✅ +15 años experiencia ✅ Mejor precio garantizado. Valoración sin compromiso en 2h. Llamar: 932 932 913',
    keywords: 'desguace Gavá, desguace en Gavá, vender coche siniestrado Gavá, retirar coche averiado Gavá, compra coches siniestrados Gavá, chatarra coches Gavá, desguace coches Gavá, grúa coches Gavá, baja coche Gavá, desguace Baix Llobregat',
    canonical: 'https://desguacesengava.com/'
  },
  servicios: {
    title: 'Servicios Desguace Gavá 【2026】Compra Coches Siniestrados | Recogida Gratis | Baja DGT | ☎️ 932 932 913',
    description: '🔧 Servicios completos de desguace en Gavá: ✅ Compra de coches siniestrados y averiados ✅ Recogida gratuita con grúa 24h ✅ Gestión de baja en DGT ✅ Venta de piezas de segunda mano ✅ Reciclaje ecológico ✅ Certificado de destrucción. Atención profesional en Gavá, Castelldefels, Viladecans y todo el Baix Llobregat. Llamar: 932 932 913',
    keywords: 'servicios desguace Gavá, compra coches siniestrados Gavá, recogida gratis coches Gavá, baja DGT Gavá, piezas segunda mano Gavá, reciclaje vehículos Gavá, certificado destrucción Gavá',
    canonical: 'https://desguacesengava.com/servicios'
  },
  comoVender: {
    title: 'Cómo Vender tu Coche en Gavá 【2026】Guía Completa | Valoración Gratis | Proceso Rápido | ☎️ 932 932 913',
    description: '📋 Guía completa para vender tu coche siniestrado o averiado en Gavá: ✅ Paso 1: Valoración gratuita en 2h ✅ Paso 2: Recogida gratis en 24h ✅ Paso 3: Pago inmediato en efectivo ✅ Documentación necesaria ✅ Gestión de baja incluida ✅ Sin trámites ni complicaciones. Proceso 100% transparente en Gavá y Baix Llobregat. Llamar: 932 932 913',
    keywords: 'cómo vender coche Gavá, vender coche siniestrado Gavá, valoración coche gratis Gavá, proceso venta coche Gavá, documentación venta coche Gavá, vender coche rápido Gavá',
    canonical: 'https://desguacesengava.com/como-vender-tu-coche'
  },
  blog: {
    title: 'Blog Desguace Gavá 【2026】Guías, Consejos y Noticias sobre Venta de Coches Siniestrados | ☎️ 932 932 913',
    description: '📰 Blog especializado en desguace y venta de coches en Gavá: ✅ Guías paso a paso ✅ Consejos de expertos ✅ Precios actualizados 2026 ✅ Documentación y trámites ✅ Normativa DGT ✅ Reciclaje y medio ambiente. Información actualizada sobre compra-venta de vehículos siniestrados, averiados y para chatarra en Gavá y Baix Llobregat.',
    keywords: 'blog desguace Gavá, guías venta coches Gavá, consejos desguace Gavá, precios chatarra 2026 Gavá, documentación baja coche Gavá, noticias desguace Gavá',
    canonical: 'https://desguacesengava.com/blog'
  },
  faq: {
    title: 'Preguntas Frecuentes Desguace Gavá 【2026】Dudas sobre Venta de Coches | Precios | ☎️ 932 932 913',
    description: '❓ Resolvemos todas tus dudas sobre desguace en Gavá: ✅ ¿Cuánto pagan por mi coche? ✅ ¿Qué documentos necesito? ✅ ¿Cuánto tarda la recogida? ✅ ¿Cómo se tramita la baja? ✅ ¿Qué coches compran? ✅ ¿El servicio es gratuito? Respuestas de expertos con +15 años de experiencia en Gavá y Baix Llobregat. Llamar: 932 932 913',
    keywords: 'preguntas frecuentes desguace Gavá, dudas venta coche Gavá, precio coche chatarra Gavá, documentación desguace Gavá, FAQ desguace Gavá',
    canonical: 'https://desguacesengava.com/preguntas-frecuentes'
  }
};

export const updatePageSEO = (page: keyof typeof seoConfig) => {
  const seo = seoConfig[page];
  if (!seo) return;

  document.title = seo.title;
  
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', seo.description);
  }
  
  const metaKeywords = document.querySelector('meta[name="keywords"]');
  if (metaKeywords) {
    metaKeywords.setAttribute('content', seo.keywords);
  }
  
  const linkCanonical = document.querySelector('link[rel="canonical"]');
  if (linkCanonical) {
    linkCanonical.setAttribute('href', seo.canonical);
  }

  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) {
    ogTitle.setAttribute('content', seo.title);
  }

  const ogDescription = document.querySelector('meta[property="og:description"]');
  if (ogDescription) {
    ogDescription.setAttribute('content', seo.description);
  }

  const ogUrl = document.querySelector('meta[property="og:url"]');
  if (ogUrl) {
    ogUrl.setAttribute('content', seo.canonical);
  }

  const twitterTitle = document.querySelector('meta[name="twitter:title"]');
  if (twitterTitle) {
    twitterTitle.setAttribute('content', seo.title);
  }

  const twitterDescription = document.querySelector('meta[name="twitter:description"]');
  if (twitterDescription) {
    twitterDescription.setAttribute('content', seo.description);
  }
};
